package pancapp

import computation.ComputationLogic

import scala.util.Try

case class ProtocolValues(a: Double,
                          b: Double,
                          c: Double,
                          d: Double,
                          e: Double,
                          f: Int,
                          g: Double) extends Serializable {
  def r1: Double = {
    val (r1, r2) = ComputationLogic.compute(a, b, c, d, e, a1, a2, g)
    r1
  }

  def r2: Double = {
    val (r1, r2) = ComputationLogic.compute(a, b, c, d, e, a1, a2, g)
    r2
  }

  def a1: Double = ComputationLogic.getFValValue(f)._1

  def a2: Double = ComputationLogic.getFValValue(f)._2

  def h: Double = 0.1 * a * c

  def i: Double = c * g / 10

  def j: Double = i * a / 100

  def mnozstviNovehoPojiva: Double = 10 * b - j - h

  def createQueryParams(): String = {
    s"?" +
      s"a=$a&" +
      s"b=$b&" +
      s"c=$c&" +
      s"d=$d&" +
      s"e=$e&" +
      s"f=$f&" +
      s"g=$g"
  }
}

object ProtocolValues {
  def fromQueyParams(url: String): ProtocolValues = {
    val argMap = Try {
      val args = url.split('?').last
      args
        .takeWhile(c => c != '#')
        .split("&")
        .map(arg => {
          val keyValItems = arg.split("=")
          keyValItems match {
            case Array(k, v, _*) => k -> v
          }
        }).toMap
    }.getOrElse(Map.empty)

    val protocolVals = ProtocolValues(
      Try(argMap("a").toDouble).getOrElse(50),
      Try(argMap("b").toDouble).getOrElse(5.51),
      Try(argMap("c").toDouble).getOrElse(5.42),
      Try(argMap("d").toDouble).getOrElse(31),
      Try(argMap("e").toDouble).getOrElse(60),
      Try(argMap("f").toInt).getOrElse(1),
      Try(argMap("g").toDouble).getOrElse(4))

    protocolVals
  }
}


// WEBPACK FOOTER //
// /home/petr/repos/pancapp/javascriptApp/src/main/scala/pancapp/ProtocolValues.scala